/* global axios */
import ApiClient from '../ApiClient';

class CarCatalogAPI extends ApiClient {
  constructor() {
    super('car_catalog', { accountScoped: true, wgpt: true });
  }

  get() {
    return axios.get(this.url);
  }

  getModels(makeId) {
    return axios.get(`${this.url}/models`, { params: { make_id: makeId } });
  }

  getTrims(modelId) {
    return axios.get(`${this.url}/trims`, { params: { model_id: modelId } });
  }

  createMake(data) {
    return axios.post(`${this.url}/makes`, data);
  }

  createModel(data) {
    return axios.post(`${this.url}/models`, data);
  }

  createTrim(data) {
    return axios.post(`${this.url}/trims`, data);
  }

  createColor(data) {
    return axios.post(`${this.url}/colors`, data);
  }

  createAlias(data) {
    return axios.post(`${this.url}/aliases`, data);
  }

  deleteAlias(aliasId) {
    return axios.delete(`${this.url}/aliases/${aliasId}`);
  }
}

export default new CarCatalogAPI();
